<template>
  <div class="header-search">
    <div class="header-search-left">
      <div class="logo-panel"></div>
      <channelSetting class="channel-style"></channelSetting>
    </div>
    <div class="header-search-right">
      <searchComp></searchComp>
    </div>
  </div>
</template>

<script>
import searchComp from './searchComp.vue'
import channelSetting from './channelSetting.vue'

export default {
  name:'headerSearch',
  components:{
    searchComp,
    channelSetting
  }
}
</script>

<style lang="scss" scoped>
.header-search {
  padding: p2r(25px) 0;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .header-search-left {
    .logo-panel {
      display: inline-block;
      background: url("../../assets/img/logo.png");
      width: p2r(342px);
      height: p2r(58px);
      margin-right: p2r(40px);
      background-size: 100% 100%;
    }

    .channel-style {
      display: inline-block;
      height: p2r(32px);
    }

    .logo-panel, .channel-style {
      vertical-align: bottom;
    }
  }

  .header-search-right {

  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/headerSearch.vue